import { Link } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { api, fmtMoney, methodLabel, errMsg } from "@/lib/api";
import { PageHeader, EmptyState, CustomerLink, ImportBadge, DocDate } from "@/components/common";
import { useQuick } from "@/components/Layout";
import { Button } from "@/components/ui/button";

export default function Payments() {
  const quick = useQuick();
  const qc = useQueryClient();
  const { data: payments = [] } = useQuery({ queryKey: ["payments"], queryFn: () => api.get("/payments").then((r) => r.data) });
  const month = new Date().toISOString().slice(0, 7);
  const thisMonth = payments.filter((p) => p.date.startsWith(month)).reduce((a, p) => a + p.amount, 0);
  const remove = async (p) => { if (!window.confirm("Delete this payment?")) return; try { await api.delete(`/payments/${p.id}`); qc.invalidateQueries(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div data-testid="payments-page">
      <PageHeader title="Payments" subtitle={`${fmtMoney(thisMonth)} received this month`} action={<Button onClick={() => quick.newPayment()} className="btn-orange h-10" data-testid="manual-income-button"><Plus size={16} /> Manual Income</Button>} />
      {payments.length === 0 ? <EmptyState title="No payments yet" /> : (
        <div className="card-flat divide-y divide-slate-100" data-testid="payments-list">
          {payments.map((p) => (
            <div key={p.id} className="flex items-center gap-3 p-4" data-testid="payment-row">
              <div className="w-10 h-10 rounded-lg bg-emerald-50 text-emerald-700 grid place-items-center text-[10px] font-bold uppercase shrink-0">{methodLabel(p.method).split(" ")[0].slice(0, 5)}</div>
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-sm"><CustomerLink customer={p.customer} />{p.invoice_number ? <Link to={`/invoices/${p.invoice_id}`} className="text-xs font-mono text-slate-400 ml-2 hover:underline">{p.invoice_number}</Link> : <span className="text-xs text-slate-400 ml-2">Manual income</span>}<ImportBadge doc={p} className="ml-2" /></div>
                <div className="text-xs text-slate-500 truncate"><DocDate doc={p} dateKey="date" /> | {methodLabel(p.method)}{p.reference ? ` | ${p.reference}` : ""}{p.description ? ` | ${p.description}` : ""}</div>
              </div>
              <span className="font-semibold tabular-nums text-emerald-700">+{fmtMoney(p.amount)}</span>
              <button onClick={() => remove(p)} className="text-slate-300 hover:text-red-600 p-1" data-testid="payment-delete-button"><Trash2 size={15} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
